export type PremiumUserTypeKey =
  | 'PROFESSIONAL_ATHLETE'
  | 'PERSONAL_TRAINER_COACH'
  | 'OTHER'
  | 'ASSOCIATION_CLUB';

/** Standard user without an active premium role. */
export type StandardUserTypeKey = 'USER';

export type UserTypeFilterKey = StandardUserTypeKey | PremiumUserTypeKey;

export const USER_TYPE_FILTER_OPTIONS: { label: string; value: '' | UserTypeFilterKey }[] = [
  { label: 'All user types', value: '' },
  { label: 'User', value: 'USER' },
  { label: 'Personal Trainer / Coach', value: 'PERSONAL_TRAINER_COACH' },
  { label: 'Professional Athlete', value: 'PROFESSIONAL_ATHLETE' },
  { label: 'Other Pro users', value: 'OTHER' },
  { label: 'Association / Club', value: 'ASSOCIATION_CLUB' },
];

const PREMIUM_ROLE_KEY_ALIASES: Record<string, PremiumUserTypeKey> = {
  PERSONAL_TRAINER: 'PERSONAL_TRAINER_COACH',
};

export function normalizePremiumRoleKey(key?: string | null): PremiumUserTypeKey | undefined {
  if (!key?.trim()) {
    return undefined;
  }

  const normalized = key.trim().toUpperCase().replace(/[\s-]+/g, '_') as PremiumUserTypeKey;
  const known: PremiumUserTypeKey[] = [
    'PROFESSIONAL_ATHLETE',
    'PERSONAL_TRAINER_COACH',
    'OTHER',
    'ASSOCIATION_CLUB',
  ];

  if (known.includes(normalized)) {
    return normalized;
  }

  return PREMIUM_ROLE_KEY_ALIASES[normalized];
}

export function getUserTypeIconPath(key: string): string {
  const iconKey = normalizePremiumRoleKey(key) ?? key;
  return `assets/layout/images/icons/pro_user/${iconKey}.png`;
}
